import { createContext } from "react";
import type { IAuthContext } from "./IAuthContext";

export const AuthContext = createContext<IAuthContext | undefined>(undefined);
